import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function PageHeader({
  eyebrow,
  title,
  italicTitle,
  copy,
  testId = "page-header",
}) {
  return (
    <section
      className="relative pt-32 md:pt-40 pb-14 md:pb-20 bg-black text-white border-b border-white/10"
      data-testid={testId}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 eyebrow text-zinc-500 hover:text-white transition-colors mb-8 md:mb-12"
          data-testid="page-header-back"
        >
          <ArrowLeft className="w-3 h-3" strokeWidth={1.5} />
          Home
        </Link>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
          <div className="col-span-12 md:col-span-8">
            {eyebrow && <div className="eyebrow mb-5">§ {eyebrow}</div>}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
              className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight"
            >
              {title}
              {italicTitle && (
                <>
                  <br />
                  <span className="italic text-zinc-400">{italicTitle}</span>
                </>
              )}
            </motion.h1>
          </div>
          {copy && (
            <div className="col-span-12 md:col-span-4">
              <p className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-md">
                {copy}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
